import { Base, PageObject } from '@testsigmainc/models';
import { deserialize, serializable, serialize } from 'serializr';

export class TestCasePriority extends Base implements PageObject {
  @serializable
  public displayName: string;
  @serializable
  public name: string;
  @serializable
  public projectId: number;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(TestCasePriority, input));
  }

  public serialize(): JSON {
    return serialize(this);
  }
}
